module.exports = __webpack_public_path__ + "static/media/border-center-h.db803a51.svg";